<xemex-dialog-shell [title]="'partnerships.removeInstallationGroup.title' | translate">
  <div class="p-2">
    <span>{{ 'partnerships.removeInstallationGroup.message' | translate }}</span>
    <div class="mt-3 p-3 bg-neutral-light rounded">
      <p class="font-semibold">{{ data.groupName }}</p>
    </div>
  </div>
  <mat-dialog-actions actions>
    <xemex-filled-button (click)="onConfirm()" intent="destructive">
      {{ 'general.btnRemove' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button mat-dialog-close type="button">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
